/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Language_LabelInputs */

const en_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const fr_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const it_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

const ru_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const es_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const zh_cn2_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ja_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const hi_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा`)
};

const pt_pt2_merge_event_group_language_label = /** @type {(inputs: Merge_Event_Group_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguagem`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Merge_Event_Group_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_language_label = /** @type {((inputs?: Merge_Event_Group_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_language_label(inputs)
	if (locale === "de") return de_merge_event_group_language_label(inputs)
	if (locale === "it") return it_merge_event_group_language_label(inputs)
	if (locale === "ru") return ru_merge_event_group_language_label(inputs)
	if (locale === "es") return es_merge_event_group_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_language_label(inputs)
	if (locale === "ja") return ja_merge_event_group_language_label(inputs)
	if (locale === "hi") return hi_merge_event_group_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_language_label(inputs)
	return en_merge_event_group_language_label(inputs)
});